import { SliderMark } from 'types/shared/slider-mark.type';
import { ConsumptionRateOptions } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/ofd-settings.type';

const DailyConsumptionRecommendedSliderMarks: SliderMark[] = [
  {
    value: 3,
    label: '3',
  },
  {
    value: 10,
    label: '10',
  },
  {
    value: 20,
    label: '20',
  },
  {
    value: 30,
    label: '30',
  },
];

const ConsumptionRateOptionsMock: ConsumptionRateOptions[] = [
  {
    days: 0,
    kg: 3000,
  },
  {
    days: 1,
    kg: 2000,
  },
  {
    days: 2,
    kg: 2300,
  },
  {
    days: 3,
    kg: 2400,
  },
  {
    days: 4,
    kg: 2500,
  },
  {
    days: 5,
    kg: 3300,
  },
  {
    days: 6,
    kg: 3000,
  },
  {
    days: 7,
    kg: 3000,
  },
  {
    days: 8,
    kg: 3400,
  },
  {
    days: 9,
    kg: 3900,
  },
  {
    days: 10,
    kg: 2000,
  },
  {
    days: 11,
    kg: 3000,
  },
  {
    days: 12,
    kg: 4000,
  },
  {
    days: 13,
    kg: 5000,
  },
  {
    days: 14,
    kg: 6000,
  },
  {
    days: 15,
    kg: 7000,
  },
  {
    days: 16,
    kg: 2000,
  },
  {
    days: 17,
    kg: 2000,
  },
  {
    days: 18,
    kg: 2000,
  },
  {
    days: 19,
    kg: 2000,
  },
  {
    days: 20,
    kg: 4500,
  },
  {
    days: 21,
    kg: 25000,
  },
  {
    days: 22,
    kg: 21000,
  },
  {
    days: 23,
    kg: 26000,
  },
  {
    days: 24,
    kg: 92000,
  },
  {
    days: 25,
    kg: 12000,
  },
  {
    days: 26,
    kg: 8000,
  },
  {
    days: 27,
    kg: 43000,
  },
  {
    days: 28,
    kg: 26000,
  },
  {
    days: 29,
    kg: 5000,
  },
  {
    days: 30,
    kg: 7000,
  },
];

export { ConsumptionRateOptionsMock, DailyConsumptionRecommendedSliderMarks as RecommendedMarks };
